module.exports = __webpack_public_path__ + "img/20180815_151844_198.f3e82e7a.jpg";